import { render, staticRenderFns } from "./bankAsideEmpty.vue?vue&type=template&id=32b33a18"
import script from "./bankAsideEmpty.vue?vue&type=script&lang=js"
export * from "./bankAsideEmpty.vue?vue&type=script&lang=js"
import style0 from "./bankAsideEmpty.vue?vue&type=style&index=0&id=32b33a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports